var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Strip',{staticClass:"address-strip",class:{ empty: !_vm.value },on:{"click":_vm.handleClick}},[_vm._v("\n    "+_vm._s(_vm.value || '请添加收货地址')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }